
<script>
import dropdownIcon from '@/assets/images/icons/arrow-dropdown.svg?inline'

export default {
  name: 'filters-field',
  components: {
    dropdownIcon
  },
  props: {
    label: {
      type: String,
      default: () => '',
      required: true
    },
    commonStyle: {
      type: Boolean,
      default: false
    },
    defaultOpen: {
      type: Boolean,
      default: () => false
    },
    isLoading: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    showContent: false
  }),
  created() {
    this.showContent = this.defaultOpen
  },
}
</script>
<template>
  <div
    class="filters-field"
    :class="{
      'filters-field--common': commonStyle
    }"
  >
    <div
      class="filters-field__header"
      :class="{
        'filters-field__header': isLoading
      }"
    >
      <button
        :disabled="isLoading"
        @click="showContent = !showContent"
      >
        <dropdown-icon
          class="filters-field__header-icon"
          :class="{
            'filters-field__header-icon--down': showContent && !isLoading
          }"
        />
        <span>{{ label }}</span>
      </button>
    </div>
    <div
      v-if="(showContent || commonStyle) && !isLoading"
      class="filters-field__content"
    >
      <slot />
    </div>
  </div>
</template>
